"use client";

import { c as _c } from "react/compiler-runtime";
import { useChosenOffice } from "@/app/components/SmileStickyHeader/useChosenOffice";
import { toSmileAnalyticsOffice } from "@/app/components/SmileStickyHeader/smileAnalyticsOffice";
import { useAppContext } from "@/app/contextProviders/app-context";
import { mergeSmileHeaderNavItems } from "@/lib/utils/smile-chrome/header-nav-entry";
import { SmileHeader as BaseSmileHeader, type SmileHeaderProps } from "./SmileHeader";
import { useSmileHeaderNavEntry } from "./SmileHeaderEntryContext";

/**
 * Studio boundary for the /smile header atom — the SchedulingWidgetWithContextDefault.tsx
 * analog. Reads useAppContext() for selectedOffice (the same server-seeded
 * office every other /smile chrome piece trusts) and passes it through as
 * the base component's first-paint fallback, and forwards the SDK-injected
 * isEditorMode prop so the native nearest-office ladder stays inert on the
 * Studio canvas. This is the export registered in studio-components.ts.
 */
export const SmileHeader = props => {
  const $ = _c(13);
  const {
    selectedOffice
  } = useAppContext();
  const entryNav = useSmileHeaderNavEntry();
  let t0;
  if ($[0] !== entryNav || $[1] !== props.navItems) {
    t0 = mergeSmileHeaderNavItems(props.navItems, entryNav);
    $[0] = entryNav;
    $[1] = props.navItems;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const navItems = t0;
  let t1;
  if ($[3] !== selectedOffice) {
    t1 = selectedOffice?.name && selectedOffice.slug ? {
      label: selectedOffice.name,
      href: `/dentist${selectedOffice.slug.replace(/\/+$/, "")}/`,
      code: selectedOffice.code
    } : null;
    $[3] = selectedOffice;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const initialOffice = t1;
  const chosenOffice = useChosenOffice(selectedOffice, !props.isEditorMode);
  let t2;
  if ($[5] !== selectedOffice) {
    t2 = toSmileAnalyticsOffice(selectedOffice);
    $[5] = selectedOffice;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const analyticsOffice = t2;
  const t3 = props.initialOffice ?? initialOffice;
  const t4 = props.chosenOffice ?? chosenOffice;
  const t5 = props.analyticsOffice ?? analyticsOffice;
  let t6;
  if ($[7] !== navItems || $[8] !== props || $[9] !== t3 || $[10] !== t4 || $[11] !== t5) {
    t6 = <BaseSmileHeader {...props} navItems={navItems} initialOffice={t3} chosenOffice={t4} analyticsOffice={t5} />;
    $[7] = navItems;
    $[8] = props;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};